import { Injectable } from '@angular/core';
import { empty } from 'rxjs';

/**
 * Serviço e validação de CPF
 */
@Injectable({
  providedIn: 'root'
})
export class ValidaCpfService {
  constructor() {}

  public validarCPF(cpf: string) {
    cpf = this.retirarMascara(cpf);
    if (
      cpf.length != 11 ||
      cpf == '00000000000' ||
      cpf == '11111111111' ||
      cpf == '22222222222' ||
      cpf == '33333333333' ||
      cpf == '44444444444' ||
      cpf == '55555555555' ||
      cpf == '66666666666' ||
      cpf == '77777777777' ||
      cpf == '88888888888' ||
      cpf == '99999999999'
    )
      return false;

    if (cpf != null) {
      var soma;
      var resto;
      soma = 0;
      for (let i = 1; i <= 9; i++)
        soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
      resto = (soma * 10) % 11;
      if (resto == 10 || resto == 11) resto = 0;
      if (resto != parseInt(cpf.substring(9, 10))) return false;
      soma = 0;
      for (let i = 1; i <= 10; i++)
        soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
      resto = (soma * 10) % 11;
      if (resto == 10 || resto == 11) resto = 0;
      if (resto != parseInt(cpf.substring(10, 11))) return false;
      return true;
    } else {
      return false;
    }
  }

  public retirarMascara(cpf: string): string {
    if (cpf !== null && cpf !== undefined && cpf !== '') {
      const exp = /\.|\-|\//g;
      cpf = cpf.toString().replace(exp, '');
      return cpf;
    } else {
      return null;
    }
  }

  aplicarMascaraNumerica(valor: any): string {
    let novoValor = '';

    for (let i = 0; i < valor.length; i++) {
      const aux = valor[i].replace(/^[^[0-9]]*$/, '');
      novoValor += aux;
    }

    return novoValor;
  }

  aplicarMascara(valor: any, regex: any) {
    let novoValor = '';

    for (let i = 0; i < valor.length; i++) {
      const aux = valor[i].replace(regex, '');
      novoValor += aux;
    }

    return novoValor;
  }
}
